module.exports = __webpack_public_path__ + "static/media/vaisakh.036a226b.pdf";